import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/rapidELearningTool'

export default function RapidELearningTool() {
  return <ProjectLayout data={data} />
}
